<template>
    <div class="session-detail-component">
        <div class="session-detail-component-contents">
            <div class="session-detail-component-contents-right-column-container">
                <div class="session-detail-component-contents-right-column">
                    <img class="next-event-photo" src="../../assets/final-march-24-banner.png" alt="Next event">

                    <div class="session-detail-component-contents-right-column-guides-1">
                        <class class="session-detail-component-contents-right-column-guides-title-container">
                             <div class="session-detail-component-contents-right-column-guides-title-ガイド">Hosts</div>
                        </class>
                        <hr class="separator">
                        <!-- <div class="session-detail-separator"></div> -->
                        <div class="session-detail-component-contents-right-column-guide">
                            <img class="session-detail-component-contents-right-column-guide-photo" src="../../assets/takuma-face.png" alt="Haruki face">

                            <div class="session-detail-component-contents-right-column-guide-text-container">
                                <div class="session-detail-component-contents-right-column-guide-name">Takuma Kobayashi</div>
                                <div class="session-detail-component-contents-right-column-guide-role">Event facilitator </div>
                                <div class="session-detail-component-contents-right-column-guide-description">Takuma provides coaching to educational institutions and companies throughout Japan. He will guide you through the sauna and ice bath at the event.</div>
                            </div>
                        </div>
                        <!-- <div class="session-detail-separator"></div> -->
                        <div class="session-detail-component-contents-right-column-guide-martin">
                            <img class="session-detail-component-contents-right-column-guide-photo" src="../../assets/martin-face.jpg" alt="Haruki face">

                            <div class="session-detail-component-contents-right-column-guide-text-container-martin">
                                <div class="session-detail-component-contents-right-column-guide-name">Martin Maly</div>
                                <div class="session-detail-component-contents-right-column-guide-role">Event DJ </div>
                                <div class="session-detail-component-contents-right-column-guide-description">Martin is an international DJ from Canada who has DJ’d at various events around the world. He will curate the music for the event. </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="session-detail-component-contents-right-column-place-1">
                        <class class="session-detail-component-contents-right-column-place-title-container">
                             <div class="session-detail-component-contents-right-column-place-title-8">8 attending</div>
                        </class>
                        <hr class="separator">
                        <div class="session-detail-separator"></div>
                        <div class="session-detail-component-contents-right-column-place-contents">
                            <div class="avatars">
                        <span class="avatar">
                                <img  src="../../assets/kei.png">
                            </span>
                        <span class="avatar">
                                <img src="../../assets/kay.png">
                            </span>
                        <span class="avatar">
                                <img src="../../assets/red.png">
                            </span>
                        <span class="avatar">
                            <img src="../../assets/green.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/blue.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/green.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/red.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/blue.png">
                            </span>
                        </div>
                        <div class="session-detail-component-contents-right-column-guide-role-x">Kei Yonenkura, Kay Tang + 6 others </div>
                        </div>

                        <div class="session-detail-component-contents-right-column-place-contents">
                            <div class="session-detail-component-contents-right-column-place-contents-text-container">
                                <div class="session-detail-component-contents-right-column-place-name-xyzy"><a href="https://www.instagram.com/elevate.jp/" target="_blank" rel="noopener noreferrer">Instagram</a></div>
                                <div class="session-detail-component-contents-right-column-place-name-xyz"><a href="mailto:elevatesocialwellness@gmail.com" target="_blank" rel="noopener noreferrer">Contact</a></div>
                            </div>
                        </div>
                    </div> -->

                    
                </div>  
            </div>

            <div class="session-detail-component-contents-left-column-container">
                <div class="session-detail-component-contents-left-column-title">Sauna+Ice Bath: Social</div>

                <div class="session-detail-component-contents-right-column-place">
                        <div class="session-detail-separator"></div>
                        <div class="session-detail-component-contents-right-column-place-contents">
                            <div class="session-detail-component-contents-right-column-place-contents-text-container-1">
                                <div class="hubhubhub-container">
                                    <div class="calendar-box-container">
                                        <img class="calendar-box" src="../../assets/calendar.png" alt="Next event">
                                    </div>
                                   

                                 <div class="hubhub-container">
                                    <div class="session-detail-component-contents-right-column-place-name-extra-info">Sunday, March 24</div>
                                    <div class="session-detail-component-contents-right-column-place-name-extra-info-again">4:30 PM - 7:00 PM</div>
                                </div>
                                </div>
                                
                            </div>

                            <div class="session-detail-component-contents-right-column-place-contents-text-container">
                                <div class="hubhubhub-container">
                                    <div class="calendar-box-container">
                                        <img class="calendar-box" src="../../assets/map-pin.png" alt="Next event">
                                    </div>
                                   

                                 <div class="hubhub-container">
                                    <div ><a class="session-detail-component-contents-right-column-place-name-link-stuff" href="https://www.google.com/maps/place/HUBHUB新百合ヶ丘/@35.6052913,139.5023333,17z/data=!3m1!4b1!4m6!3m5!1s0x6018fb013644bfdf:0xa3a7e5c250302247!8m2!3d35.6052913!4d139.5049082!16s%2Fg%2F11ty6xbxmr?entry=ttu" target="_blank" rel="noopener noreferrer">HUBHUB Shin-Yurigaoka</a></div>
                                    <div class="session-detail-component-contents-right-column-place-name-extra-info-again">渋谷駅から電車で33分</div>
                                </div>
                                </div>
                                
                            
                            </div>



                            <div class="session-detail-component-contents-right-column-place-date-and-time"> <br> <br> </div>
                        </div>
                    </div>

                <div class="session-detail-component-contents-right-column-payment">
                        <class class="session-detail-component-contents-right-column-payment-container">
                             <div class="session-detail-component-contents-right-column-payment-title">Registration</div>
                        </class>
                        <div class="session-detail-separator"></div>

                        <div class="session-detail-component-contents-right-column-payment-contents-text-container">
                            <div class="session-detail-component-contents-right-column-price-ticket">Ticket price</div>
                            <div class="session-detail-component-contents-right-column-price">¥3000</div>
                        </div>

                        <div class="session-detail-component-contents-right-column-payment-contents-text-container">
                            <div class="session-detail-component-contents-right-column-price-sub">
定員：25名 <br>
申込締切：3月22日(金）<br></div>
                        </div>

                        <a
                            href="https://lu.ma/event/evt-RLIPelfXxpAwnoo"
                            class="session-detail-component-contents-right-column-payment-sign-up"
                            data-luma-action="checkout"
                            data-luma-event-id="evt-RLIPelfXxpAwnoo"
                        >
                        3月24日(日)に参加する
  </a>
                    </div>

                    <div class="session-detail-component-contents-left-column-subtitle">About</div>

                    <hr class="separator">

                    <div class="session-detail-component-contents-left-column-subtitle-subtitle">ELEVATEは日本初のソーシャル・ウェルネスクラブです。<br>
ハイパフォーマンス（起業家/クリエイティブ/アーティスト/アスリート）が<br>
サウナ、アイスバス、ブレスワークを通して心と身体を最適化するための新しい体験を提供しています。<br>
日本では、アルコール消費が史上最低水準に達しており、人々は健康と創造性にアルコールが及ぼす悪影響を大々的に認識し始めています。<br>
しかし、アルコールは人々を「オープン」かつ「自由に」つなぐ役割を担っていました。<br>
私たちは人々が心と身体を健康に、そして「オープン」かつ「自由に」つながることができる文化の新しい象徴としてとしてこのイベントを提供します。<br>
本物の環境で築く人々とのネットワークをお楽しみください。
</div>
<div class="horizontal-con">
    <div class="session-detail-component-contents-left-column-subtitle-subtitle-sauna-1"><br>What is a</div>
    <div class="session-detail-component-contents-left-column-subtitle-subtitle-sauna-2"><br>social sauna</div>
    <div class="session-detail-component-contents-left-column-subtitle-subtitle-sauna-3"><br>?</div>
</div>

<div class="session-detail-component-contents-left-column-subtitle-subtitle">人々が繋がる場所です。<br>
ヨーロッパやアメリカの文化で、サウナはビジネスを行ったり、新しい繋がりを作り、関係性を強化するのには最適な場所と見なされています。<br>
ELEVATEのソーシャルサウナは、人と人とが「同じ時間」・「体験」を共有し、つながる場所です。<br>
人種や宗教やセクシャリティといった壁はそこになく、自由で、思慮深い人たちが集まります。 サウナ内で行われる瞑想のセッションでは、今まで体験したことのない不思議な快感や気付かなかった内なる自分を感じるかもしれません。<br>
単に、ととのう場所としてだけではなく、あなたのソーシャルライフをより豊かにしてくれるはずです。<br>
</div>

<div class="horizontal-con">
    <div class="session-detail-component-contents-left-column-subtitle-subtitle-sauna-1"><br>What is an</div>
    <div class="session-detail-component-contents-left-column-subtitle-subtitle-ice-2"><br>ice bath</div>
    <div class="session-detail-component-contents-left-column-subtitle-subtitle-sauna-3"><br>?</div>
</div>

<div class="session-detail-component-contents-left-column-subtitle-subtitle">自身の内なる強さを育む場所です。 <br> 
ウィム・ホフ（オランダの極限アスリートでギネス世界記録保持者）によってヨーロッパで人気になり、世界中の人々が心と体を最適化するために、約0°Cの水に飛び込んでいます。 <br>
アイスバスは、世界中の多くの超一流のアスリート、アーティスト、クリエイティブたちが取り入れています。 <br>
アスリート（プレミアリーグ、MMAファイター、プロサーファーなど） <br>
セレブリティ（シルベスター・スタローン、アンソニー・ロビンスなど） <br>
ビジネスリーダー（ツイッターの共同創設者ジャック・ドーシー）など、 <br>
すべてがアイスバスの力を活用しています。 <br>
その効果は今も世界中の医療機関で科学的検証が進んでいます。 <br><br>
主なアイスバスの利点以下です。 <br>
 ・明瞭さと創造性の向上 <br>
・気分の向上 <br>
・エネルギーの増加 <br>
・回復力の向上 <br>
・エンドルフィンの放出 <br> <br>
アイスバスでは、放出されるエンドルフィンの効果により、達成感や誇りを感じることができます。人々は、より開放的で自由な感覚を人々にもたらします。<br>
ELEVATEのガイドが、他の参加者と共に乗り越える2分間のアイスバスチャレンジを案内します。

<div class="horizontal-con">
    <div class="session-detail-component-contents-left-column-subtitle-subtitle-sauna-1"><br>Who is this event for?</div>
</div>

<div class="session-detail-component-contents-left-column-subtitle-subtitle">ELEVATEは、よりより人生を望む様々な人々がつながる場所として愛されています。<br> <br>
以下の方々にお勧めします：<br>
・起業家、クリエイティブな人々、アスリート<br>
・他の高い成果を目指す個人と繋がりたい方々<br>
・心と体、キャリア、オールライフを同時に強化したい方々<br>
・自分の心と体の能力を深く理解したい方々<br>
・健康を促進し、身体的および精神的な力を向上させたい方々<br>
・健康的かつ刺激的なソーシャルアクティビティーを探している方々<br>
・「ととのい」の先を体験したいサウナユーザー<br><br>
参加を予定している参加者：<br>
・渋谷に本拠を置くエンターテインメント会社のCEO<br>
・日本に拠点を置くAI会社のCEO<br>
・カナダに拠点を置くビジュアルエフェクト会社のCTO<br>
・受賞歴のあるコンセプトアーティスト、写真家、DJたち<br><br>
このイベントは、男性、女性、参加可能です。<br>
以前にサウナやアイスバスの経験は必要ありません。<br>
皆様のご参加をお待ちしております。<br>
</div>

</div>

<div class="session-detail-component-contents-left-column-subtitle">Voice</div>

                    <hr class="separator">

                    <div class="session-detail-component-contents-right-column-place-testimonial">
                            <!-- <div class="testimonial-container">
                                <div class="testimonial-vertical-container">
                                    <div class="testimonial-text-container">

                                        <div class="testimonial-text-text">
                                            「 」
                                        </div>  
                                    </div>
                                    

                                    <div class="testimonial-person-container">
                                            <div class="testimonial-person-containre-continer">
                                                <div class="testimonial-name">
                                                Kei Y.
                                            </div>
                                            <div class="testimonial-position">
                                                woww.ai - Founder CEO
                                            </div>
                                        </div>

                                        <img class="session-detail-component-contents-right-column-guide-photo-test" src="../../assets/kei-testimonial.jpeg" alt="Haruki face">
                                    </div>
                                </div>
                            </div> -->

                            <div class="testimonial-container">
                                <div class="testimonial-vertical-container">
                                    <div class="testimonial-text-container">
        
                                        <div class="testimonial-text-text">
                                            「全部が初めての体験だったので、全て満遍なく価値を感じた。参加が2回目となり、一度体験を味わってくると、人と繋がれるという所に価値があるかも知れない。またお酒ではない活動で、人と繋がることができるのが良かった。
アイスバスへ一緒に入ることで、一緒に困難を乗り越えた感覚があった。案外いけるな～と5分以上入っていた。自分に勝った感じがあって。自分のマインドの声に打ち勝った。1人でやっていたら上がってた。みんながいる手前、1人だけ出る訳にはいかない。2分という一つの区切りを設定されていたのが良かった。達成感があった。2分超えたあたりからマインド的にはずーっといける状態になっていた。」
                                        </div>  
                                    </div>
                                    

                                    <div class="testimonial-person-container">
                                            <div class="testimonial-person-containre-continer">
                                                <div class="testimonial-name">
                                                Kiichi M.
                                            </div>
                                            <div class="testimonial-position">
                                                株式会社X Capital - コンサルタント マネジャー
                                            </div>
                                        </div>

                                        <img class="session-detail-component-contents-right-column-guide-photo-test" src="../../assets/lad.png" alt="Haruki face">
                                    </div>
                                </div>
                            </div>

                            <div class="testimonial-container">
                                <div class="testimonial-vertical-container">
                                    <div class="testimonial-text-container">

                                        <div class="testimonial-text-text">
                                            「 サウナの中で話すことでそとよりも裸だし、ワークの中でやっているからなのかリラックスした状態で心理的な壁が少ないと感じた。カフェで話すと肩肘張って探り合いがあるが、今回のイベントでは変に見栄を張らず自分らしく話しやすかった。「遊びの中で喋る」、ワークの中で喋っているから見栄を張る必要や、自分を作る必要がない。」
                                        </div>  
                                    </div>
                                    

                                    <div class="testimonial-person-container">
                                            <div class="testimonial-person-containre-continer">
                                                <div class="testimonial-name">
                                                Kan N.
                                            </div>
                                            <div class="testimonial-position">
                                                株式会社Kenxin - Founder CEO
                                            </div>
                                        </div>

                                        <img class="session-detail-component-contents-right-column-guide-photo-test" src="../../assets/kan.jpeg" alt="Haruki face">
                                    </div>
                                </div>
                            </div>

                            <div class="testimonial-container">
                                <div class="testimonial-vertical-container">
                                    <div class="testimonial-text-container">
                                        <div class="testimonial-text-text">
                                            「 ELEVATEで初めてブレスワークと氷風呂を体験しましたが、最初から大好きになりました。
素晴らしい仲間たち、素晴らしい雰囲気、そして素晴らしい音楽。来る前は少し緊張していましたが、
皆さんがとても歓迎してくれて、すぐに安心感を感じることができました。」
                                        </div>  
                                    </div>
                                    

                                    <div class="testimonial-person-container">
                                            <div class="testimonial-person-containre-continer">
                                                <div class="testimonial-name">
                                                Alina V.
                                            </div>
                                            <div class="testimonial-position">
                                                 Atlas Technologies - Business Development Coordinator
                                            </div>
                                        </div>

                                        <img class="session-detail-component-contents-right-column-guide-photo-test" src="../../assets/alina.webp" alt="Haruki face">
                                    </div>
                                </div>
                            </div>


                            <div class="testimonial-container">
                                <div class="testimonial-vertical-container">
                                    <div class="testimonial-text-container">

                                        <div class="testimonial-text-text">
                                            「 上裸の人もいたり、サウナのような狭い空間で話してるからこそ、プライベートな空間、更にお互いの深い所にディグしていきやすい環境だと思った。過去パートで、端っこで泣いていた。それを感じながら皆ここで同じ体験しているとなった時に、他者と周波数/感情が同調リンクした感覚を感じた。涙は、悲しみではなく喜びの涙。」
                                        </div>  
                                    </div>
                                    

                                    <div class="testimonial-person-container">
                                            <div class="testimonial-person-containre-continer">
                                                <div class="testimonial-name">
                                                Leon T.
                                            </div>
                                            <div class="testimonial-position">
                                               caliclub.tokyo (calisthenics club) - Founder
                                            </div>
                                        </div>

                                        <img class="session-detail-component-contents-right-column-guide-photo-test" src="../../assets/leon.jpeg" alt="Haruki face">
                                    </div>
                                </div>
                            </div>

                            <div class="testimonial-container">
                                <div class="testimonial-vertical-container">
                                    <div class="testimonial-text-container">

                                        <div class="testimonial-text-text">
                                            「 サウナも氷風呂も、このイベントが絶対に気に入った。来月また参加するのが楽しみです。」
                                        </div>  
                                    </div>
                                    

                                    <div class="testimonial-person-container">
                                            <div class="testimonial-person-containre-continer">
                                                <div class="testimonial-name">
                                                Samuel Z.
                                            </div>
                                            <div class="testimonial-position">
                                                Swiss photographer, a Fujifilm ambassador and the editor of Fujifeed
                                            </div>
                                        </div>

                                        <img class="session-detail-component-contents-right-column-guide-photo-test" src="../../assets/samuel.png" alt="Haruki face">
                                    </div>
                                </div>
                            </div>
                    </div>


                    <div class="session-detail-component-contents-left-column-subtitle">Timeline</div>

                    <hr class="separator">

                    <class class="session-detail-component-contents-left-column-information-box-container">
                        
                        <div class="session-detail-component-contents-left-column-information-box-title-container-1">
                            <div class="session-detail-component-contents-left-column-information-box-title">受付、着替え</div>
                            <div class="session-detail-component-contents-left-column-information-box-time">(4:30 PM - 5:00 PM)</div>
                            <div class="session-detail-component-contents-left-column-information-box-time"></div>
                        </div>

                        <div class="session-detail-component-contents-left-column-information-box-content-container">
                            <div class="session-detail-component-contents-left-column-information-box-content-left-column">
                                <div class="session-detail-component-contents-left-column-information-box-content-left-column-information">16:30から受付が始まります。受付後は着替えてととのいスペースにてお待ちください。暖かい部屋とお茶をご用意しておりますので、17:00~イベント開始までリラックスしてお待ち頂けます。</div>
                            </div>
                            <div class="session-detail-component-contents-left-column-information-box-content-right-column">
                                <img class="session-detail-component-contents-left-column-information-box-content-right-column-image" src="../../assets/check-in.jpg" alt="Breathwork preperation">
                            </div>
                        </div>
                        
                    </class>

                    <class class="session-detail-component-contents-left-column-information-box-container">
                        
                        <div class="session-detail-component-contents-left-column-information-box-title-container">
                            <div class="session-detail-component-contents-left-column-information-box-title">ガイド付きサウナ＋アイスバス</div>
                            <div class="session-detail-component-contents-left-column-information-box-time">(5:00 PM - 6:00 PM)</div>
                        </div>

                        <div class="session-detail-component-contents-left-column-information-box-content-container">
                            <div class="session-detail-component-contents-left-column-information-box-content-left-column">
                                <div class="session-detail-component-contents-left-column-information-box-content-left-column-information">この時間帯はガイドサウナ体験をお楽しみ頂きます。音楽のBPMに合わせた呼吸法ガイド、タオルウェイビング、アロマロウリュウ。その後、ガイドによる2分間のアイスバス体験が待っています。水風呂より難易度は高いですが、乗り越えた先に別次元の多幸感や開放感が待っています。</div>
                            </div>
                            <div class="session-detail-component-contents-left-column-information-box-content-right-column">
                                <img class="session-detail-component-contents-left-column-information-box-content-right-column-image" src="../../assets/guide.png" alt="Breathwork learning">
                            </div>
                        </div>
                    </class>

                    <class class="session-detail-component-contents-left-column-information-box-container">
                        
                        <div class="session-detail-component-contents-left-column-information-box-title-container">
                            <div class="session-detail-component-contents-left-column-information-box-title">自由時間</div>
                            <div class="session-detail-component-contents-left-column-information-box-time">(6:00 PM - 7:00 PM)</div>
                        </div>

                        <div class="session-detail-component-contents-left-column-information-box-content-container">
                            <div class="session-detail-component-contents-left-column-information-box-content-left-column">
                                <div class="session-detail-component-contents-left-column-information-box-content-left-column-information">ソーシャルサウナやティールームでDJの音楽を楽しみながら、自由に人と話をしてください。再び体験したい場合は、アイスバスのガイドが利用可能です。</div>
                            </div>
                            <div class="session-detail-component-contents-left-column-information-box-content-right-column">
                                <img class="session-detail-component-contents-left-column-information-box-content-right-column-image" src="../../assets/people-talking.png" alt="Breathwork post-glow">
                            </div>
                        </div>
                        
                    </class>


                <div class="session-detail-component-contents-left-column-subtitle">Video</div>

                <hr class="separator">
                
                
                <div class="instagram-media-container">
                    <blockquote class="instagram-media" data-instgrm-permalink="https://www.instagram.com/reel/C3PuTiKpN2U/?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style="background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);">
    <div style="padding:16px;">
        <a href="https://www.instagram.com/reel/C3PuTiKpN2U/?utm_source=ig_embed&amp;utm_campaign=loading" style="background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank">
            <div style="display: flex; flex-direction: row; align-items: center;">
                <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div>
                <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;">
                    <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div>
                    <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div>
                </div>
            </div>
            <div style="padding: 19% 0;"></div>
            <div style="display:block; height:50px; margin:0 auto 12px; width:50px;">
                <svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g transform="translate(-511.000000, -20.000000)" fill="#000000">
                            <g>
                                <path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path>
                            </g>
                        </g>
                    </g>
                </svg>
            </div>
            <div style="padding-top: 8px;">
                <div style="color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div>
            </div>
            <div style="padding: 12.5% 0;"></div>
            <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;">
                <div>
                    <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div>
                    <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div>
                    <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div>
                </div>
                <div style="margin-left: 8px;">
                    <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div>
                    <div style="width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div>
                </div>
                <div style="margin-left: auto;">
                    <div style="width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div>
                    <div style="background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div>
                    <div style="width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div>
                </div>
            </div>
            <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;">
                <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div>
                <div style="background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div>
            </div>
        </a>
        <p style="color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;">
            <a href="https://www.instagram.com/reel/C3PuTiKpN2U/?utm_source=ig_embed&amp;utm_campaign=loading" style="color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by ELEVATE (@elevate.jp)</a>
        </p>
    </div>
</blockquote>

                </div>

                <div class="session-detail-component-contents-left-column-subtitle">Map</div>

<hr class="separator">

<div class="session-detail-component-contents-right-column-place">
        <div class="session-detail-component-contents-right-column-map-contents">
            <img class="session-detail-component-contents-right-column-map-contents-photo" src="../../assets/updated_hub_hub_floor_map.png" alt="In the house">
        </div>
</div>

<div class="session-detail-component-contents-right-column-guides-2">
                        <class class="session-detail-component-contents-right-column-guides-title-container">
                             <div class="session-detail-component-contents-right-column-guides-title-ガイド">Hosts</div>
                        </class>
                        <hr class="separator">
                        <!-- <div class="session-detail-separator"></div> -->
                        <div class="session-detail-component-contents-right-column-guide">
                            <img class="session-detail-component-contents-right-column-guide-photo" src="../../assets/takuma-face.png" alt="Haruki face">

                            <div class="session-detail-component-contents-right-column-guide-text-container">
                                <div class="session-detail-component-contents-right-column-guide-name">Takuma Kobayashi</div>
                                <div class="session-detail-component-contents-right-column-guide-role">Event facilitator </div>
                                <div class="session-detail-component-contents-right-column-guide-description">Takuma provides coaching to educational institutions and companies throughout Japan. He will guide you through the sauna and ice bath at the event. </div>
                            </div>
                        </div>
                        <!-- <div class="session-detail-separator"></div> -->
                        <div class="session-detail-component-contents-right-column-guide-martin">
                            <img class="session-detail-component-contents-right-column-guide-photo" src="../../assets/martin-face.jpg" alt="Haruki face">

                            <div class="session-detail-component-contents-right-column-guide-text-container-martin">
                                <div class="session-detail-component-contents-right-column-guide-name">Martin Maly</div>
                                <div class="session-detail-component-contents-right-column-guide-role">Event DJ </div>
                                <div class="session-detail-component-contents-right-column-guide-description">Martinはカナダ出身の国際的なDJで、世界中の様々なイベントでDJをしています。彼がイベントの音楽的な雰囲気をカレーティングします。 </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="session-detail-component-contents-right-column-place-2"> -->
                        <!-- <class class="session-detail-component-contents-right-column-place-title-container">
                             <div class="session-detail-component-contents-right-column-place-title-8">8 attending</div>
                        </class>
                        <hr class="separator">
                        <div class="session-detail-separator"></div>
                        <div class="session-detail-component-contents-right-column-place-contents">
                            <div class="avatars">
                        <span class="avatar">
                                <img  src="../../assets/kei.png">
                            </span>
                        <span class="avatar">
                                <img src="../../assets/kay.png">
                            </span>
                        <span class="avatar">
                                <img src="../../assets/red.png">
                            </span>
                        <span class="avatar">
                            <img src="../../assets/green.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/blue.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/green.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/red.png">
                            </span>

                            <span class="avatar">
                                <img src="../../assets/blue.png">
                            </span>
                        </div>
                        <div class="session-detail-component-contents-right-column-guide-role-x">Kei Yonenkura, Kay Tang + 6 others </div>
                        </div>

                        <div class="session-detail-component-contents-right-column-place-contents">
                            <div class="session-detail-component-contents-right-column-place-contents-text-container">
                                <div class="session-detail-component-contents-right-column-place-name-xyzy"><a href="https://www.instagram.com/elevate.jp/" target="_blank" rel="noopener noreferrer">Instagram</a></div>
                                <div class="session-detail-component-contents-right-column-place-name-xyz"><a href="mailto:elevatesocialwellness@gmail.com" target="_blank" rel="noopener noreferrer">Contact</a></div>
                            </div>
                        </div>
                    </div> -->
            </div>
        </div>
    </div>
</template>


<script>
export default {
    mounted () {
        this.$nextTick(() => {
            // Existing Instagram embed code
            if (window.instgrm) {
                window.instgrm.Embeds.process();
            } else {
                let instaScript = document.createElement('script');
                instaScript.async = true;
                instaScript.src = "//www.instagram.com/embed.js";
                instaScript.onload = () => window.instgrm.Embeds.process();
                document.head.appendChild(instaScript);
            }

            // Load Lu.ma checkout button script
            if (!window.LuMa) { // Check if the Lu.ma script is not already loaded
                let lumaScript = document.createElement('script');
                lumaScript.id = 'luma-checkout';
                lumaScript.src = 'https://embed.lu.ma/checkout-button.js';
                document.head.appendChild(lumaScript);
            }
        });
    }
}
</script>

<style scoped>
.testimonial-container {
    margin-bottom: 40px;
}

.session-detail-component {
         min-height: calc(100vh - 110px);
        /* display: flex; */
        align-items: center;
        justify-content: top;
        flex-direction: column;
        background: rgb(34, 32, 37);
        padding-top: 20pt;
    }

    .testimonial-person-container {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .testimonial-name {
        color: white;
        font-family: SFProRegular;
        font-size: 12pt;
        text-align: right;
    }

    .testimonial-position {
        color: rgb(225, 228, 118);
        font-family: SFProRegular;
        font-size: 12pt;
        text-align: right;
    }

    .separator {
        color: rgb(120,120,120);
        border-color: rgb(120,120,120);
        background-color: rgb(120,120,120);
        border: 1;

        display: block;
  height: 1px;
  border: 0;
  margin: 1em 0;
  padding: 0px;
    }

.session-detail-component-contents {
    display: grid;
    grid-template-columns: 34% 66%;
    max-width: 960px; 
    gap: 0px;
	margin: 0 auto !important; 
	float: none !important; 
}

.session-detail-component-contents-right-column-guide-description {
    font-family: SFPRoLight;
    font-size: 12pt;
    color: rgb(208, 208, 208);
}

.five-star {
    color: rgb(243,216,82);
    padding-bottom: 10px;
}

.testimonial-text-text {
    color: white;
    font-family: SFPRoRegular;
}

.session-detail-component-contents-right-column-place-name-xyzy {
    margin-top: 15px;
}

.session-detail-component-contents-right-column-place-name-xyz {
    margin-top: 5px;
}

.horizontal-con {
    display: flex;
    padding-bottom: 4px;
}

.avatars {
    margin-top: -10px;
}

.instagram-media-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

    .next-event-photo {
        /* width: auto; */
        width: 100%;
        margin-right: 0px;
        border-radius: 15px;
        display: inline-flex;
        margin-bottom: 10px;
    }

    .avatar {
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  width: 50px;
}

.avatar:not(:first-child) {
  margin-left: -30px;
  -webkit-mask:radial-gradient(circle 27.5px at 5px 50%,transparent 99%,#fff 100%);
          mask:radial-gradient(circle 27.5px at 5px 50%,transparent 99%,#fff 100%);
}

.avatar img {
  width: 100%;
  display: block;
}

.session-detail-component-contents-left-column-container {
    /* padding: 20px; */
    padding-left: 16px;
    padding-right: 16px;
}

.calendar-box-container {
    width: 40px;
    height: 40px;
    margin-right: 15px;
    border-radius: 5px;
    border:1px solid clear;
}
.calendar-box {
    width: 30px;
    height: 40px;
    margin-right: 15px;
    border-radius: 5px;
    margin: auto;
    display: block;
    justify-content: center;
    object-fit: contain;
}

.hubhubhub-container {
    display: flex;
    vertical-align: middle;
    align-items: center;
}

.session-detail-component-contents-left-column {
    background: rgb(35,32,38);
    border-radius: 10px;
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
    border-radius: 10px;
}

.session-detail-component-contents-left-column-title-container {
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: left;
    margin-right: 16px;
    padding-top: 8px;
    padding-bottom: 4px;
    text-align: left;
    width: auto;
}
.session-detail-component-contents-left-column-title {
    font-family: SFPRoBold;
    font-size:40pt;
    color: white;
    align-items: left;
    justify-content: left;
    margin-bottom: 10px;
}

.session-detail-component-contents-left-column-subtitle {
    font-family: SFPRoBold;
    font-size: 16pt;
    color: white;
    align-items: left;
    justify-content: left;
    text-align: left;
    margin-top: 30px;
    margin-bottom: -5px;
}

.hubhub-container {
}

.session-detail-component-contents-left-column-subtitle-subtitle {
    font-family: SFPRoRegular;
    font-size: 12pt;
    color: white;
    align-items: left;
    justify-content: left;
    text-align: left;
}

.session-detail-component-contents-left-column-subtitle-subtitle-sauna-1 {
    font-family: SFPRoBold;
    font-size: 14pt;
    color: white;
    align-items: left;
    justify-content: left;
    text-align: left;
    padding-right: 3px;
}
.session-detail-component-contents-left-column-subtitle-subtitle-sauna-2 {
    font-family: SFPRoBold;
    font-size: 14pt;
  background: -webkit-linear-gradient(rgb(243,216,82), rgb(233, 52,37));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
    align-items: left;
    justify-content: left;
    text-align: left;
}
.session-detail-component-contents-left-column-subtitle-subtitle-ice-2 {
    font-family: SFPRoBold;
    font-size: 14pt;
  background: -webkit-linear-gradient(rgb(108,227,238), rgb(78, 170,239));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
    align-items: left;
    justify-content: left;
    text-align: left;
}

.session-detail-component-contents-left-column-subtitle-subtitle-sauna-3 {
    font-family: SFPRoBold;
    font-size: 14pt;
    color: white;
    align-items: left;
    justify-content: left;
    text-align: left;
}

.session-detail-component-contents-left-column-information-box-container {
    padding: 0px;
    display: flex;
    flex-direction: column;
}

.session-detail-component-contents-left-column-information-box-title-container-1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding-top: 0px;
}

.session-detail-component-contents-left-column-information-box-title-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding-top: 20px;
}

.session-detail-component-contents-left-column-information-box-title {
    font-family: SFPRoRegular;
    font-size: 14pt;
    color: white;
}

.session-detail-component-contents-left-column-information-box-time {
    font-family: SFPRoRegular;
    font-size: 14pt;
    color: grey;
}

.session-detail-component-contents-left-column-information-box-content-container {
    display: grid;
    grid-template-columns: 1fr;
    margin-top: 16px;
}

.session-detail-component-contents-left-column-information-box-content-left-column {
    flex: 50%;
}

.session-detail-component-contents-left-column-information-box-content-left-column-information {
    font-family: SFPRoLight;
    font-size: 12pt;
    color: white;
}

.session-detail-component-contents-left-column-information-box-content-right-column {
    flex: 50%;
    display: flex;
    align-items: center;
    /* justify-content: right; */
}

.session-detail-component-contents-left-column-information-box-content-right-column-image {
    object-fit: cover;
    height: 300px;
    border-radius: 10px;
    width: 100%;
    margin-top: 10px;
}

.session-detail-separator {
    background: rgb(35,32,38);
    border-radius: 10px;
    height: 2px;
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
border-radius: 10px;
}

.session-detail-component-contents-right-column-container {
    padding: 5px;
}

.session-detail-component-contents-right-column-guides-1 {
    background: rgb(35,32,38);
    border-radius: 10px;
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
border-radius: 10px;
    padding: 0px;
    margin: 0px;
}

.session-detail-component-contents-right-column-guides-2 {
    background: rgb(35,32,38);
    border-radius: 10px;
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
border-radius: 10px;
    padding: 0px;
    margin: 0px;
    display: none;
}

.session-detail-component-contents-right-column-guides-title-container {
    display: flex;
    align-items: center;
}
.session-detail-component-contents-right-column-guides-title {
    font-family: SFPRoBold;
    font-size: 16pt;
    color: white;
    margin-bottom: -10px;
    /* margin-top: ; */
}

.session-detail-component-contents-right-column-guides-title-ガイド {
    font-family: SFPRoBold;
    font-size: 16pt;
    color: white;
    margin-bottom: -10px;
    margin-top: 15px;
}


.session-detail-component-contents-right-column-guide {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    /* padding-left: 16px;
    padding-right: 16px; */
    /* padding-top: 8px; */
    padding-bottom: 8px;
}

.session-detail-component-contents-right-column-guide-martin {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    /* padding-left: 16px;
    padding-right: 16px; */
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 20px;
}

.session-detail-component-contents-right-column-guide-photo {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-right: 8px;
}

.session-detail-component-contents-right-column-guide-photo-test {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-left: 10px;
    /* padd */
}

.session-detail-component-contents-right-column-guide-text-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
}


.session-detail-component-contents-right-column-guide-name {
    font-family: SFPRoRegular;
    font-size: 12pt;
    color: white;
}

.session-detail-component-contents-right-column-guide-role {
    font-family: SFPRoLight;
    font-size: 12pt;
    color: rgb(225, 228, 118)
}

.session-detail-component-contents-right-column-guide-role-x {
    font-family: SFPRoLight;
    font-size: 12pt;
    color: rgb(208, 208, 208);
    padding-top: 5px;
}

.session-detail-component-contents-right-column-place-1 {
    background: rgb(35,32,38);
    border-radius: 10px;
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
border-radius: 10px;
}

.session-detail-component-contents-right-column-place-2 {
    background: rgb(35,32,38);
    border-radius: 10px;
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
border-radius: 10px;
display: none;
}

.session-detail-component-contents-right-column-place-title-container {
    display: flex;
    align-items: center;
    /* margin-left: 16px;
    margin-right: 16px; */
    height: 35px;
    /* padding-top: 6px; */
    margin-bottom: -10px;
}

.session-detail-component-contents-right-column-place-title {
    font-family: SFPRoBold;
    font-size: 16pt;
    color: white;
}

.session-detail-component-contents-right-column-place-title-8 {
    font-family: SFPRoBold;
    font-size: 16pt;
    color: white;
}

.session-detail-component-contents-right-column-place-contents {
    display: flex;
flex-direction: column;
    /* align-items: center; */
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 8px;
    padding-bottom: 8px;
}

.session-detail-component-contents-right-column-map-contents {
    display: flex;
    align-items: center;
    align-content: center;
    padding-left: 16px;
    padding-right: 16px;
    /* padding-top: 8px; */
    padding-bottom: 8px;
}

.session-detail-component-contents-right-column-place-contents-photo {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    margin-right: 8px;
}

.session-detail-component-contents-right-column-map-contents-photo {
    max-width: 100%;
    margin: auto;
}

.session-detail-component-contents-right-column-place-contents-text-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.session-detail-component-contents-right-column-place-contents-text-container-1 {
    margin-bottom: 14px;
}

.session-detail-component-contents-right-column-place-name-link-stuff {
    font-family: SFPRoBold;
    font-size: 12pt;
    color: white;
}

/* unvisited link */
.session-detail-component-contents-right-column-place-name-link-stuff:link {
  color: white;
}

/* visited link */
.session-detail-component-contents-right-column-place-name-link-stuff:visited {
  color: white;
}

/* mouse over link */
.session-detail-component-contents-right-column-place-name-link-stuff:hover {
  color: white;
}

/* selected link */
.session-detail-component-contents-right-column-place-name-link-stuff:active {
  color: white;
}


.session-detail-component-contents-right-column-payment-sign-up:link {
    color: black;
}

.session-detail-component-contents-right-column-payment-sign-up:visited {
    color: black;
}

.session-detail-component-contents-right-column-payment-sign-up:hover {
    color: black;
}

.session-detail-component-contents-right-column-payment-sign-up:active {
    color: black;
}

.session-detail-component-contents-right-column-place-name-extra-info {
    font-family: SFPRoBold;
    font-size: 12pt;
    color: white;
    padding-top: 0px;
}

.session-detail-component-contents-right-column-place-name-extra-info-again {
    font-family: SFPRoRegular;
    font-size: 12pt;
    color: rgb(208, 208, 208);
    padding-top: 5px;
}

.session-detail-component-contents-right-column-place-date-and-time {
    font-family: SFPRoLight;
    font-size: 10pt;
    color: white;
}

.session-detail-component-contents-right-column-payment {
    background: rgb(35,32,38);
    border-radius: 10px;
    /* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%23333' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e"); */
border-radius: 10px;
    display: flex;
    flex-direction: column;
    /* background-color: red; */
    border:1px solid rgb(120,120,120);
    box-shadow: rgba(10, 10, 10, 0.35) 0px 5px 15px;
    margin-bottom: 10px;
    margin-top: -10px;
}

.session-detail-component-contents-right-column-payment-container {
    display: flex;
    align-items: center;
    /* margin-left: 16px;
    margin-right: 16px; */
}

.session-detail-component-contents-right-column-payment-title {
    font-family: SFPRoBold;
    font-size: 16pt;
    color: white;
    margin-left: 16px;
    margin-top: 10px;
}

.session-detail-component-contents-right-column-payment-contents-text-container {
    align-items: center;
    margin-left: 16px;
    margin-right: 16px;
    padding-top: 8px;
    padding-bottom: 8px;
}

.session-detail-component-contents-right-column-price-ticket {
    font-family: SFPRoRegular;
    font-size: 12pt;
    color: rgb(208, 208, 208);;
    padding-bottom: 2px;
    padding-top: 5px;
}

.session-detail-component-contents-right-column-price {
    font-family: SFProBold;
    font-size: 16pt;
    color: white;
}

.session-detail-component-contents-right-column-price-sub {
    font-family: SFProRegular;
    font-size: 12pt;
    color: white;
}


.session-detail-component-contents-right-column-payment-sign-up {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 8px;
    margin-bottom:16px;
    height: 40px;
    cursor:pointer;
    background-color: rgb(225, 228, 118);
    border: none;
    border-radius: 8px;
    color: black;
    font-family: SFPRoBold;
    font-size: 16px;
    transition: 300ms;
    text-align: center;
    line-height: 40px;
    text-decoration:none;
}

.session-detail-component-contents-right-column-payment-sign-up:hover {
  background: #9c9e2b;
}

@media only screen and (max-width: 1000px) {
    .session-detail-component-contents {
        display: grid;
        grid-template-columns: 1fr;
    }

}

@media only screen and (max-width: 1000px) {
    .session-detail-component-contents-left-column-information-box-content-right-column {
        justify-content: center;
        margin-top: 15px;
    }

    .session-detail-component-contents-left-column-information-box-content-container {
        display: grid;
        grid-template-columns: 1fr;
    }

    /* .session-detail-component-contents-left-column-information-box-content-right-column-image {
        max-width: 350px;
    } */

    .session-detail-component-contents-right-column-container {
    /* padding: 5px; */
    padding-left: 16px;
    padding-right: 16px;
}

    .session-detail-component-contents-right-column-guides-1 {
        display: none;
    }

    .session-detail-component-contents-right-column-guides-2 {
        display: block;
    }

    .session-detail-component-contents-right-column-place-1 {
        display: none;
    }
    
    .session-detail-component-contents-right-column-place-2 {
        display: block;
    }

    .session-detail-component {
        margin-top: -80px;
        margin-bottom: 50px;
    }
}
</style>
